// src/app/core/helpers/http-helper.service.ts
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '@environments/environment'; // Updated path alias

@Injectable({
  providedIn: 'root'
})
export class HttpHelperService {
  private baseUrl = environment.apiBaseUrl;

  private buildUrl(endpoint: string): string {
    const base = (this.baseUrl || '').replace(/\/+$/g, '');
    const path = (endpoint || '').replace(/^\/+/, '');
    const url = `${base}/${path}`;
    if (!base) {
      console.warn('[HttpHelperService] environment.apiBaseUrl is empty. Request will be relative:', url);
    }
    return url;
  }

  constructor(private http: HttpClient) { }

  get<T>(endpoint: string, params?: { [key: string]: any }): Observable<T> {
    const httpParams = this.buildParams(params);
    return this.http.get<T>(this.buildUrl(endpoint), { params: httpParams });
  }

  post<T>(endpoint: string, body: any): Observable<T> {
    return this.http.post<T>(this.buildUrl(endpoint), body);
  }

  put<T>(endpoint: string, body: any): Observable<T> {
    return this.http.put<T>(this.buildUrl(endpoint), body);
  }

  delete<T>(endpoint: string): Observable<T> {
    return this.http.delete<T>(this.buildUrl(endpoint));
  }
  downloadFile(url: string): Observable<any> {
    return this.http.get(this.buildUrl(url), { responseType: 'blob' })
  }
  private buildParams(params?: { [key: string]: any }): HttpParams {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach(key => {
        if (params[key] !== undefined && params[key] !== null) {
          httpParams = httpParams.set(key, params[key].toString());
        }
      });
    }
    return httpParams;
  }

}